import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { SidebarConfig } from '../../config/sidebar-config';
import { Helpers } from '../../helpers';


@Injectable({
    providedIn: 'root'
})
export class SidebarConfigService {
    menu$: BehaviorSubject<any> = new BehaviorSubject<any>({});

    constructor() {
        this.getMenu();
    }

    /** Get the sidebar configuration */
    getMenu() {
        if(Helpers.role() === 'ADMIN')
        {
            this.menu$.next((new SidebarConfig()).configs);
        }
    }
}
